import React from 'react';
import Reflux from 'reflux';
import EDPSeatmap from '../../components/edp';
import TicketPriceInfo from '../../components/edp/ticketpriceinfo';
import fullscreen   from '../../stores/fullscreen';
import config       from '../../stores/edpconfig';
import filters      from '../../stores/edpfilters';
import deliveryfees from '../../stores/deliveryfees';
import basket       from '../../stores/basket';
import eventinfo    from '../../stores/eventinfo';
import BasketActions from '../../actions/basket';
import translate from '../../utils/translate';
import {getTicketPriceText, getTicketPriceRange, getTicketPriceRangeString} from '../../utils/ticketprice';
import Button from '../../components/common/button';
import SearchIcon2 from '../../components/common/icons/icon_search2';
import withDevice from '../../components/common/withDeviceHOC';

export class EDP extends Reflux.Component {
  constructor (props) {
    super(props);

    this.state = {};
    this.mapStoreToStateKey(basket, 'basket');
    this.mapStoreToStateKey(filters, 'filters');
    this.mapStoreToStateKey(fullscreen, 'fullscreen');
    this.mapStoreToStateKey(config, 'config');
    this.mapStoreToStateKey(deliveryfees, 'deliveryfees');
    this.mapStoreToStateKey(eventinfo, 'eventinfo');
  }

  mapStoreToStateKey = (store, key) => {
    this.mapStoreToState(store, changes => {
      this.setState(currentState => ({ [key]: {...currentState[key], ...changes} }));
    });
  };

  goToBestAvailable = () => {
    BasketActions.goToBestAvailable(this.state.basket.config.eventId);
  };

  renderBestAvailable = () => {
    return (
      !this.props.isMobile &&
      <Button primary outlined icontext onClick={this.goToBestAvailable}>
        <SearchIcon2 />
        {translate('pageTranslations', 'FIND_SEATS_FOR_ME')}
      </Button>
    );
  };

  render () {
    let text = getTicketPriceText(this.state.basket.currency);
    let headerText = this.props.isMobile
      ? getTicketPriceRangeString(getTicketPriceRange(this.state.basket.prices), text, this.state.basket.moneyFormat)
      : translate('pageTranslations', 'PICK_YOUR_SEATS');

    return (
      <div className="edpcontent">
        <div className="edpcontent__ticketpriceinfo">
          <TicketPriceInfo
            headerText={headerText} text={text}
            basket={this.state.basket} deliveryfees={this.state.deliveryfees} />
          {this.renderBestAvailable()}
        </div>
        <EDPSeatmap {...this.state} />
      </div>
    );
  }
}

export default withDevice(EDP);



// WEBPACK FOOTER //
// ./frontend/react/apps/edp/index.js